var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineaPunteada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 933.88 128.47",
    style: {
      enableBackground: "new 0 0 933.88 128.47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;stroke-dasharray:10;}\r\n\t.st1{display:none;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;stroke-dasharray:10.0866,10.0866;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,84.26c0,0,88.94-72,160.94-24s138.35,24,138.35,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.29,81.26c0,0,88.94-72,160.94-24s138.35,24,138.35,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.59,78.71c0,0,88.94-72,160.94-24s138.35,24,138.35,24"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-190.25-592.15c0,0,1.12,1.37,3.27,3.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-180.07-581.02c31.11,31.83,130.11,117.23,248.83,57.87c138.73-69.37,143.81-91.39,226.26-71.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.91-593.39c1.59,0.4,3.2,0.81,4.84,1.24"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaPunteada);
export default __webpack_public_path__ + "static/media/lineaPunteada.cf0097ff9b31cfdf2cc46e798fe6ad89.svg";
export { ForwardRef as ReactComponent };